class sectionTwotier extends HTMLElement {
    constructor() {
      super();
      this.tabheading = this.querySelectorAll('.tabheading_btn');
      this.tabdetailes = this.querySelectorAll('.sec-Section_Inner__soh');
  
      if (!this.tabheading) return;
  
      this.init();
    }
  
    init() {
      this.tabheading.forEach((tab, i) => {
        const tabContent = tab.getAttribute('data-id');
        const firstEle = this.querySelector(`#${tabContent}`);
        const firstEleSlider =  firstEle.querySelector('.slider-flickity');
        if(i == 0){
          const options = JSON.parse(firstEleSlider.getAttribute('data-option'));
          const flkty = new Flickity( firstEleSlider, options);
          flkty.resize();
        }
        tab.addEventListener("click", (e) => {
          const tabcontent = e.currentTarget.getAttribute('data-id');
          const tabcontentEle = this.querySelector(`#${tabcontent}`);
          this.tabheading.forEach(item => {item.classList.remove('active')});
          this.tabdetailes.forEach(item => {item.style.display = "none"});
          e.currentTarget.classList.add('active');
          tabcontentEle.style.display = "block";
          const tabcontentEleSlider =  firstEle.querySelector('.slider-flickity');
          if(!tabcontentEleSlider.classList.contains('flickity-enabled')){
            const options = JSON.parse(tabcontentEleSlider.getAttribute('data-option'));
            const flkty = new Flickity( tabcontentEleSlider, options);
            flkty.resize();
          }
        });
      });
    }
  }
  
  customElements.define('section-twotier', sectionTwotier);